export default function permission() {
  return 0
}

export function getPermissions(state) {
  return state.permissions
}
